import styled from "styled-components";

export const Container = styled.div`
    display: block;
    width: 100%;
    margin-top: 20px;
`;

export const DistributionContainer = styled.div`
    display: inline;
`;
